import * as React from 'react'

import { i18n } from '@thg-commerce/enterprise-core'
import { useSiteConfig } from '@thg-commerce/enterprise-core/src/ConfigurationLoader'
import {
  Country,
  Currency,
} from '@thg-commerce/enterprise-network/src/generated/graphql'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { Separator } from '@thg-commerce/gravity-elements'
import { MarketedSpecialOfferSummaryContainer } from '@thg-commerce/gravity-patterns'

import { useProductPage } from '../../context'

interface MarketedSpecialOfferSummaryRendererProps {
  topPositionPdp?: boolean
}

export type MarketedSpecialOfferSummaryQueryArgs = {
  sku: number
  currency: Currency
  shippingDestination: Country
}
export interface LandingPageLink {
  text: string
  url: string
  openExternally: boolean
  noFollow: boolean
  __typename?: 'LandingPageLink' | string
}

export interface Images {
  largeProduct: string
  __typename?: 'Images' | string
}

export interface Rrp {
  displayValue: string
  __typename?: 'RRP' | string
}

export interface FreeGiftProduct {
  images: Images[]
  title: string
  price: {
    rrp: Rrp
    __typename?: 'Price' | string
  }
  __typename?: 'FreeGiftProduct' | string
}

export interface MarketedSpecialOfferSummary {
  title: string
  description: string
  landingPageLink?: LandingPageLink
  freeGiftProduct?: FreeGiftProduct | null
  __typename?: 'ProductMarketedSpecialOffer' | string
}
export interface CloseI18nText {
  closeAriaLabel: string
  closeLabel: string
}

export interface I18nText {
  closeI18nText: CloseI18nText
  freeGiftMessage?: string
}

export interface MarketedSpecialOfferSummaryQueryResult {
  productMarketedSpecialOffer: MarketedSpecialOfferSummary
  loading?: boolean
  i18nText: I18nText
  showIcon?: boolean
}

export const MarketedSpecialOfferSummaryRenderer = (
  props: MarketedSpecialOfferSummaryRendererProps,
) => {
  const { selectedVariant } = useProductPage()

  const {
    showMarketedSpecialOfferIcon,
    papMessageTopPosition,
    showPapMessageAboveBNPL,
    hideCTAOnMarketSpecialOffer,
  } = useSiteConfig()

  const i18nText = {
    closeI18nText: {
      closeAriaLabel: i18n('general.modal.close.button.arialabel'),
      closeLabel: i18n('general.modal.close.button.label'),
    },
    freeGiftMessage: i18n('product.marketedspecialoffer.freegift.text'),
  }

  if (!selectedVariant?.marketedSpecialOffer) {
    return null
  }

  return (
    <React.Fragment>
      <MarketedSpecialOfferSummaryContainer
        {...selectedVariant.marketedSpecialOffer}
        onlyDisplayOfferBadge={props.topPositionPdp}
        reduceBottomMarginContainer={props.topPositionPdp}
        freeGiftProduct={
          selectedVariant.marketedSpecialOffer.freeGiftProduct || undefined
        }
        landingPageLink={
          selectedVariant.marketedSpecialOffer.landingPageLink || undefined
        }
        i18nText={i18nText}
        showIcon={showMarketedSpecialOfferIcon}
        hideCTAOnMarketSpecialOffer={hideCTAOnMarketSpecialOffer}
      />

      {!showPapMessageAboveBNPL && !papMessageTopPosition && (
        <Separator withSpacing />
      )}
    </React.Fragment>
  )
}
